import * as React from "react";

import { v4 } from "uuid";

import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Badge from '@material-ui/core/Badge';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';

import "./../../resources/forest.jpg";

import { ThemeProvider } from '@material-ui/core/styles';

import { createMuiTheme } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';



import Login from "./Login";
import Exam from "./Exam";
import FinishExam from "./FinishExam";
import ResponsivePaper from "./ResponsivePaper";

import ExamServer from '../server/ExamServer'
import ExamExercise from "./ExamExercise";
import Administration from "./Administration";
import { Hidden } from "@material-ui/core";

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';


// import ResultItem, { EPSRequestState } from "./ResultItem";
// import ResultList from "./ResultList";



const theme = createMuiTheme({
    palette: {
        // primary: {
        //     main: '#44423e'
        // },
        // secondary: {
        //     main: '#FDC400',
        //     contrastText: '#fff'
        // }
    }

});

export interface LegalNoticeProps {
    onClose: () => void
    open: boolean
}

export interface LegalNoticeState {

}


class LegalNotice extends React.Component<LegalNoticeProps, LegalNoticeState> {


    constructor(props: LegalNoticeProps) {
        super(props);
    }



    render() {
        return (

            <Dialog open={this.props.open} fullWidth maxWidth={"md"}>
                <DialogTitle >{"Impressum"}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Typography variant="h5" color="textPrimary" component="h2" gutterBottom>
                            Angaben gemäß § 5 TMG
                        </Typography>
                        <Typography variant="body1" color="textPrimary" component="div" gutterBottom>
                            Curtis Crudup <br/>
                            Dozent für Business English <br/>
                            Schlossweg 16 <br/>
                            87748 Fellheim  
                        </Typography>

                        <Typography variant="body1" color="textPrimary" component="div" gutterBottom>
                            Telefon: +49 (0) 176 21243407 <br/>
                            E-Mail: ccrudrup39(at)outlook.com
                        </Typography>
                        <br/>
                        <Typography variant="body1" color="textPrimary" component="div" gutterBottom>
                            Michael Dempsey <br/>
                            Dozent für Business English <br/>
                            Freundenthatstr. 31<br/>
                            87700 Memmingen                               
                        </Typography>

                        <Typography variant="body1" color="textPrimary" component="div" gutterBottom>
                            Telefon: +49 (0) 8331 9614119 <br/>
                            E-Mail: michael.dempsey@hotmail.com
                        </Typography>
                        <br/>
                        {/* <Typography variant="h5" color="textPrimary" component="h2" gutterBottom>
                            Umsatzsteuer-ID
                        </Typography>
                        <Typography variant="body1" color="textPrimary" component="div" gutterBottom>
                            Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: <br/>
                            DE 999 999 999
                        </Typography>
                        <br/> */}
                        <Typography variant="h5" color="textPrimary" component="h2" gutterBottom>
                            EU-Streitschlichtung
                        </Typography>
                        <Typography variant="body1" color="textPrimary" component="div" gutterBottom>
                            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <br/>
                            https://ec.europa.eu/consumers/odr. <br/>
                            Unsere E-Mail-Adresse finden Sie oben im Impressum.
                        </Typography>
                        <br/>
                        <Typography variant="h5" color="textPrimary" component="h2" gutterBottom>
                            Verbraucherstreitbeilegung/Universalschlichtungsstelle
                        </Typography>
                        <Typography variant="body1" color="textPrimary" component="div" gutterBottom>
                            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
                            Verbraucherschlichtungsstelle teilzunehmen.
                        </Typography>
                        <br/>
                        <Typography variant="h5" color="textPrimary" component="h2" gutterBottom>
                            Haftung für Inhalte
                        </Typography>
                        <Typography variant="body1" color="textPrimary" component="div" gutterBottom>
                            Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den
                            allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht
                            verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
                            forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                            Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen
                            Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
                            Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden
                            Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
                        </Typography>
                        <br/>

                        <Typography variant="h5" color="textPrimary" component="h2" gutterBottom>
                            Haftung für Links
                        </Typography>
                        <Typography variant="body1" color="textPrimary" component="div" gutterBottom>
                            Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
                            Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
                            verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten
                            Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte
                            waren zum Zeitpunkt der Verlinkung nicht erkennbar.
                            Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer
                            Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links
                            umgehend entfernen.                        
                        </Typography>
                        <br/>
                        <Typography variant="h5" color="textPrimary" component="h2" gutterBottom>
                            Urheberrecht
                        </Typography>
                        <Typography variant="body1" color="textPrimary" component="div" gutterBottom>
                            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
                            Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
                            Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                            Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
                            Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter
                            beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
                            Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei
                            Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
                            Quelle:
                            e-recht24.de        
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={this.props.onClose}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>


        );
    }
}

export default LegalNotice;
